export default {
  auth: {
    LOGIN: 'login',
    LOGGED_IN: 'loggedIn',
    LOGOUT: 'logout',
  },
  applicant: {
    LOAD_CATEGORIES: 'loadCategories',
    LOAD_APPLICANTS: 'loadApplicants',
    LOAD_SCOUT_APPLICANTS:'loadScoutApplicants',
    LOAD_SELECTORS: 'loadSelectors',
    LOAD_EVENTS:'loadEvents',
    LOAD_ALL_REVIEWLIST: 'loadAllReviewList'
  },
};
